// Who may see and turn on a layer in the layer menu. Shared by the layer tiles and by
// Artemis's set_layer_visibility action (WEB-7093), so both apply the same rules.

// The layer needs a plan the user doesn't have (the tile shows the Pro blocker).
export const isLayerBlocked = (layer, userSubscriptions = []) =>
  !userSubscriptions.some(plan => (plan.subscriptionPlanId & layer.subscriptionPlanIdFlag) !== 0)

// The layer is hidden from users on certain plans.
export const isLayerHiddenBySubscription = (layer, userSubscriptions = []) => {
  if (!layer.hideIfSubscriptionFlag && !layer.hideIfPaid) {
    return false
  }
  return userSubscriptions.some(plan => {
    if (plan.subscriptionPlanId === 4 && layer.hideIfPaid) {
      return true
    }
    return (plan.subscriptionPlanId & layer.hideIfSubscriptionFlag) !== 0
  })
}

// Whether the layer menu shows a tile for this layer at all.
export const isLayerInMenu = (layer, userSubscriptions = [], productionLayers = false) =>
  !layer.hideInLayerMenu &&
  !!layer.enabled &&
  !isLayerHiddenBySubscription(layer, userSubscriptions) &&
  (!productionLayers || !!layer.production)

export const BASEMAP_LAYER_NODE_ID = 5
export const DEFAULT_BASEMAP_LAYER_ID = 81

export const isBasemapLayer = layer => layer.layerNodeId === BASEMAP_LAYER_NODE_ID
